function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React from 'react';

var KeycardReader = function (_React$Component) {
  _inherits(KeycardReader, _React$Component);

  var _super = _createSuper(KeycardReader);

  function KeycardReader() {
    _classCallCheck(this, KeycardReader);

    return _super.apply(this, arguments);
  }

  _createClass(KeycardReader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._onKeyInput = this._onKeyInput || this.onKeyInput.bind(this);
      document.addEventListener('keydown', this._onKeyInput);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('keydown', this._onKeyInput);
      clearTimeout(this._timer);
    }
  }, {
    key: "onKeyInput",
    value: function onKeyInput(e) {
      var character = e.key;

      if (this.isValidChar(character)) {
        this.appendInput(character);
      } else if (e.code === 'Enter') {
        this.submit(e);
      } else {
        this._input = '';
      }
    }
  }, {
    key: "isValidChar",
    value: function isValidChar(str) {
      if (str.length > 1) {
        return false;
      }

      var code = str.charCodeAt(0);
      return code >= 48 && code <= 57 || code >= 65 && code <= 70 || code >= 97 && code <= 102;
    }
  }, {
    key: "appendInput",
    value: function appendInput(character) {
      var _this = this;

      clearTimeout(this._timer);
      this._input = (this._input || '') + character;
      this._timer = setTimeout(function () {
        _this._input = '';
      }, 250);
    }
  }, {
    key: "submit",
    value: function submit(event) {
      var input = this._input || '';

      if (input.length < 1 || !this.props.onRead) {
        return;
      }

      this._input = '';
      event.preventDefault();
      event.stopPropagation();
      var serial = input.slice(0, 8);
      this.props.onRead(serial);
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(React.Fragment, null);
    }
  }]);

  return KeycardReader;
}(React.Component);

export default KeycardReader;